export const NAVROUTES = [
  {
    text: "Home",
    link: "/"
  },
  {
    text: "Offers",
    link: "/category/offers"
  },
  {
    text: "Profile",
    link: "/profile"
  },
  {
    text: "SignIn",
    link: "/sign-in"
  },
  {
    text: "SignUp",
    link: "/sign-up"
  },
  {
    text: "Logout"
  }
];
